.description:focus {
    color: var(--blue);
    outline: none;
}
